// Sales routes (under accounting app)

const routes = [
  {
    path: "/accounting/sales",
    redirect: "/accounting/sales/analytics",
  },
  {
    path: "/accounting/sales/analytics",
    name: "SalesAnalytics",
    component: () => import("@/views/sales/SalesAnalytics.vue"),
    meta: { requiresAuth: true, requiresAdmin: true, app: ["sales", "accounting"] },
  },
  {
    path: "/accounting/sales/analytics/settings",
    name: "SalesAnalyticsSettings",
    component: () => import("@/views/sales/SalesAnalyticsSettings.vue"),
    meta: { requiresAuth: true, requiresAdmin: true, app: ["sales", "accounting"] },
  },
  {
    path: "/accounting/sales/visiera-orders",
    name: "VisieraOrders",
    component: () => import("@/views/sales/VisieraOrders.vue"),
    meta: { requiresAuth: true, requiresAdmin: true, app: ["sales", "accounting"] },
  },
  {
    // Self-service Direct (POS) sales upload for cashiers. No requiresAdmin — a
    // cashier is a plain user holding the narrow "direct-upload" app.
    path: "/accounting/direct-upload",
    name: "DirectUpload",
    component: () => import("@/views/accounting/DirectUploadView.vue"),
    meta: { requiresAuth: true, app: ["direct-upload", "accounting", "sales"] },
  },
];

export default routes;